<template>
  <div class="pbr-analysis-content">
    <el-row>
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="pbr-analysis-col-div">
          <span class="pbr-analysis-echart-span">{{ $t('charts.analysis.networkVolume.volumeInformationTrendChart') }}</span>
          <div class="pbr-analysis-echart-div" id="volume-trend"></div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="pbr-analysis-col-div">
          <span class="pbr-analysis-echart-span">{{ $t('charts.analysis.networkVolume.informationSourceTrendChart') }}</span>
          <div class="pbr-analysis-echart-div" id="information-trend"></div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="pbr-analysis-col-div">
          <span class="pbr-analysis-echart-span">{{ $t('charts.analysis.networkVolume.distributionMapOfInformationSources') }}</span>
          <div class="pbr-analysis-echart-div" id="from-distribution"></div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="pbr-analysis-col-div">
          <span class="pbr-analysis-echart-span">{{ $t('charts.analysis.networkVolume.comparisonOfInformationSources') }}</span>
          <div class="pbr-analysis-echart-div" id="information-contrast"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
    import * as echarts from 'echarts';
    import {pieChartOption, xLabelColor, chartLineOption} from "./constant";
    import ResizeObserver from 'resize-observer-polyfill'

    let volumeTrendChart;
    let fromDistributionChart;
    let informationTrendChart;
    let informationContrastChart;

    export default {
        name: "NetworkVolumeAnalysis", // 网络声量
        props: ['condition', 'exportSuccess'],
        components: {

        },
        data() {
            return {
                fromDistributionData: {},
                informationContrastData: {},
                queryParams: {},
                isResize: false,
            }
        },
        mounted() {
            window.addEventListener('resize',  () => {
              this.isResize = true;
            })
            this.queryParams = this.condition;
            this.initEcharts();
            this.echartTheme();
            this.search();
        },
        methods: {
            getTheme() {
                return this.$store.state.brpaModule.theme || 'white';
            },
            initEcharts() {
                let countContrastDom = document.getElementById('volume-trend')

                volumeTrendChart = echarts.init(countContrastDom);
                volumeTrendChart.setOption(chartLineOption);
                fromDistributionChart = echarts.init(document.getElementById("from-distribution"));
                fromDistributionChart.setOption(pieChartOption);
                informationTrendChart = echarts.init(document.getElementById("information-trend"));
                informationTrendChart.setOption(chartLineOption);
                informationContrastChart = echarts.init(document.getElementById("information-contrast"));
                informationContrastChart.setOption(pieChartOption);
                let that = this;
                let countContrastObserver = new ResizeObserver((entries) => {
                  if (that.isResize) {
                    that.resize();
                    if (entries && entries.length > 0 && entries[0].borderBoxSize[0].blockSize > 0) {
                      that.isResize = false;
                    }
                  }
                })
                countContrastObserver.observe(countContrastDom);
            },

            volumeTrendHandler(obj) {
                if (obj.length<=0){
                    volumeTrendChart.clear();
                    return ;
                }
                let series = [];
                let ser = {};
                ser["data"] = obj.map(o=>o.num);
                ser["type"] = "line";
                ser["smooth"] = true;
                series[0] = ser;
                const option = {
                    title: {
                      subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.ge')} `,
                      top: 15
                    },
                    legend: {
                        textStyle: {
                            color: xLabelColor[this.getTheme()],
                        }
                    },
                    yAxis: {
                        minInterval: 1,
                        boundaryGap : [ 0, 0.1 ],
                        axisLabel:{
                            color: xLabelColor[this.getTheme()],
                        },
                      min: function (value) {
                        let num = 0
                        if (value.min === 0) {
                          return num
                        } else if (value.min.toString().length < 2) {
                          return value.min - 1
                        } else if (value.min.toString().length < 3) {
                          return value.min - 10
                        } else {
                          num = 10 ** (value.min.toString().length - 2)
                          return Math.floor(value.min / num) * num
                        }
                      }
                    },
                    xAxis: {
                        data: obj.map(o=>o.time),
                        axisLabel: {
                            color: xLabelColor[this.getTheme()],
                        },
                    },
                    series: series,
                };

                volumeTrendChart.clear();
                volumeTrendChart.setOption(chartLineOption);
                volumeTrendChart.setOption(option);
            },

            fromDistributionHandler() {
                if (this.fromDistributionData.length<=0){
                    fromDistributionChart.clear();
                    return ;
                }
                let series = [];
                for (let i = 0; i < this.fromDistributionData.length; i++) {
                    let ser = {};
                    ser["name"] = this.fromDistributionData[i].name;
                    ser["value"] = this.fromDistributionData[i].num;
                    series[i] = ser;
                }
                const option = {
                    legend: {
                        pageIconColor: xLabelColor[this.getTheme()],
                        pageTextStyle: {
                            color:xLabelColor[this.getTheme()],
                        },
                        textStyle: {
                            color: xLabelColor[this.getTheme()],
                        }
                    },
                    series: [
                        {
                            type: 'pie',
                            top: '10%',
                            radius: '70%',
                            data: series,
                            label: {
                                show: true,
                                color: xLabelColor[this.getTheme()],
                                formatter: '{d}%'
                            },
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                };
                fromDistributionChart.clear();
                fromDistributionChart.setOption(pieChartOption);
                fromDistributionChart.setOption(option);
            },

            informationTrendHandler(obj) {
                if (obj.length<=0){
                    informationTrendChart.clear();
                    return ;
                }
                let series = [];
                for (let i = 0; i < obj.length; i++) {
                    let ser = {};
                    ser["name"] = obj[i].name;
                    ser["data"] = obj[i].nums;
                    ser["type"] = "line";
                    ser["smooth"] = true;
                    series[i] = ser;
                }
                const option = {
                    title: {
                      subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.ge')} `,
                      top: 15
                    },
                    legend: {
                        pageIconColor: xLabelColor[this.getTheme()],
                        pageTextStyle: {
                            color:xLabelColor[this.getTheme()],
                        },
                        textStyle: {
                            color: xLabelColor[this.getTheme()],
                        }
                    },
                    yAxis: {
                        minInterval: 1,
                        boundaryGap : [ 0, 0.1 ],
                        axisLabel:{
                            color: xLabelColor[this.getTheme()],
                        },
                      min: function (value) {
                        let num = 0
                        if (value.min === 0) {
                          return num
                        } else if (value.min.toString().length < 2) {
                          return value.min - 1
                        } else if (value.min.toString().length < 3) {
                          return value.min - 10
                        } else {
                          num = 10 ** (value.min.toString().length - 2)
                          return Math.floor(value.min / num) * num
                        }
                      }
                    },
                    xAxis: {
                        data: obj[0].times,
                        axisLabel: {
                            color: xLabelColor[this.getTheme()],
                        },
                    },
                    series: series,
                };
                informationTrendChart.clear();
                informationTrendChart.setOption(chartLineOption);
                informationTrendChart.setOption(option);
            },

            informationContrastHandler() {
                if (this.informationContrastData.length<=0){
                    informationContrastChart.clear();
                    return ;
                }
                let series = [];
                for (let i = 0; i < this.informationContrastData.length; i++) {
                    let ser = {};
                    ser["name"] = this.informationContrastData[i].name;
                    ser["value"] = this.informationContrastData[i].num;
                    series[i] = ser;
                }
                const option = {
                    legend: {
                        pageIconColor: xLabelColor[this.getTheme()],
                        pageTextStyle: {
                            color:xLabelColor[this.getTheme()],
                        },
                        textStyle: {
                            color: xLabelColor[this.getTheme()],
                        }
                    },
                    series: [
                        {
                            type: 'pie',
                            top: '10%',
                            radius: '70%',
                            data: series,
                            label: {
                                show: true,
                                color: xLabelColor[this.getTheme()],
                                formatter: '{d}%'
                            },
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                };
                informationContrastChart.clear();
                informationContrastChart.setOption(pieChartOption);
                informationContrastChart.setOption(option);
            },

            echartTheme() {
                const option = {
                    legend: {
                        pageIconColor: xLabelColor[this.getTheme()],
                        pageTextStyle: {
                            color:xLabelColor[this.getTheme()],
                        },
                        textStyle: {
                            color:xLabelColor[this.getTheme()],
                        }
                    },
                    xAxis: {
                        axisLabel: {
                            color: xLabelColor[this.getTheme()],
                        },
                    },
                    yAxis: {
                        axisLabel: {
                            color: xLabelColor[this.getTheme()],
                        },
                    },
                };
                if(volumeTrendChart){
                    volumeTrendChart.setOption(option);
                }

                if(fromDistributionChart){
                    const pieOption = {
                        legend: {
                            textStyle: {
                                color: xLabelColor[this.getTheme()],
                            }
                        },
                    }
                    fromDistributionChart.setOption(pieOption);
                }

                if (informationTrendChart){
                    informationTrendChart.setOption(option);
                }
                if (informationContrastChart){
                    const pieOption = {
                        legend: {
                            textStyle: {
                                color: xLabelColor[this.getTheme()],
                            }
                        },
                    }
                    informationContrastChart.setOption(pieOption);
                }
            },

            /**/
            search(){
              volumeTrendChart.showLoading({ text: this.$t('loading'), maskColor: 'transparent',textColor: xLabelColor[this.getTheme()], });
              fromDistributionChart.showLoading({ text: this.$t('loading'), maskColor: 'transparent',textColor: xLabelColor[this.getTheme()], });
              informationTrendChart.showLoading({ text: this.$t('loading'),maskColor: 'transparent', textColor: xLabelColor[this.getTheme()], });
              informationContrastChart.showLoading({ text: this.$t('loading'), maskColor: 'transparent',textColor: xLabelColor[this.getTheme()], });
                let param = {
                    from: 'cn',
                    module: 'wl' , // 模块 gj/hy/wl/xx/sj/fx 分布式国家对比、行业对比、网络声量、信息正负面、商机分析、风险分析  默认为国家对比
                };
                param = Object.assign(param, this.queryParams);
                this.$pbrAxios.post('/front/analyses/search',param).then((data) => {
                    let success = data.success;
                    if (success){
                        let sensitivityModels = data.result.sensitivityModels;
                        this.fromDistributionData = data.result.nationModels;
                        let nationLineModels = data.result.nationLineModels;
                        this.informationContrastData = data.result.siteModels;

                        this.volumeTrendHandler(sensitivityModels);
                        this.fromDistributionHandler();
                        this.informationTrendHandler(nationLineModels);
                        this.informationContrastHandler();

                    } else {

                    }
                }).finally(() => {
                    this.$emit("closeShow");
                  volumeTrendChart.hideLoading()
                  fromDistributionChart.hideLoading()
                  informationTrendChart.hideLoading()
                  informationContrastChart.hideLoading()
                })
            },
            /**/
            hsearch(){
                let param = {
                    from: 'cn',
                    module: 'wl' , // 模块 gj/hy/wl/xx/sj/fx 分布式国家对比、行业对比、网络声量、信息正负面、商机分析、风险分析  默认为国家对比
                };
                param = Object.assign(param, this.queryParams);

                console.log(param);

                this.$pbrAxios.post('/front/analyses/hsearch',param).then(data => {
                    let success = data.success;
                    if (success){
                        let sensitivityModels = data.result.sensitivityModels;
                        this.fromDistributionData = data.result.nationModels;
                        let nationLineModels = data.result.nationLineModels;
                        this.informationContrastData = data.result.siteModels;

                        this.volumeTrendHandler(sensitivityModels);
                        this.fromDistributionHandler();
                        this.informationTrendHandler(nationLineModels);
                        this.informationContrastHandler();
                    } else {

                    }
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.$emit("closeShow");
                });
            },

            resize() {
              if (volumeTrendChart!=null)
                volumeTrendChart.resize();
              if (fromDistributionChart!=null)
                fromDistributionChart.resize();
              if (informationTrendChart!=null)
                informationTrendChart.resize();
              if (informationContrastChart!=null)
                informationContrastChart.resize();
            }
        },
        activated() {
          this.isResize = true;
          this.resize();
        },
        destroyed () {
          window.removeEventListener('resize',() => {
            this.isResize = false;
          })
        },
        watch: {
            '$store.state.brpaModule.theme': {
                handler: function (val) {
                    if(fromDistributionChart){
                        this.fromDistributionHandler();
                    }
                    if(informationContrastChart){
                        this.informationContrastHandler();
                    }
                    this.echartTheme();
                }
            },
            condition: function(newval){
                this.queryParams = newval;
                if (this.queryParams.id){
                    this.hsearch();
                }else{
                    this.search();
                }
            },
            exportSuccess: function(newval){
              this.resize();
            }
        },
    }
</script>

<style scoped>
  .row {
    margin-top: 16px;
  }

  .row2 {
    margin-top: 32px;
  }

  .divCol {
    align-items: center;
    text-align: center
  }
</style>
